import { configureStore } from '@reduxjs/toolkit'
import { apiSlice } from './apiSlice' // Importar apiSlice
import authReducer from '../features/auth/authSlice' // Importar el reducer de auth

export const store = configureStore({
  reducer: {
    // Añadir el reducer generado por apiSlice
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authReducer, // Añadir el reducer de auth
  },
  // Añadir el middleware de la API habilita caching, invalidación, polling, etc.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      apiSlice.middleware
    ),
})

// Exportar el tipo de estado raíz
export type RootState = ReturnType<typeof store.getState>
// Exportar el tipo de dispatch tipado
export type AppDispatch = typeof store.dispatch 